/* @flow weak */

'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const Reflux = require('reflux');
const _ = require('lodash');
const dialogPolyfill = require('dialog-polyfill');

const ControlMixin = require('../../mixins/ControlMixin.jsx');

const AnswerActions = require('../../actions/AnswerActions.jsx');

const AnswerStore = require('../../stores/AnswerStore.jsx');
const QuestionStore = require('../../stores/QuestionStore.jsx');
const PartStore = require('../../stores/PartStore.jsx');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const SubquestionControlGrid = React.createClass({
  mixins: [ControlMixin, Reflux.listenTo(AnswerStore, 'onAnswerChange')],

  subquestionPrefix: '',
  subquestions: [],
  countQuestion: false,
  countPartsMap: {},
  modalRef: undefined,
  modalMarkup: null,
  portalElement: false,

  getInitialState() {
    // The metadata on the control grid question defines what the prefix all subquestions start with.
    this.subquestionPrefix = _.get(this.props.question, 'metadata.SubquestionControlPrefix');
    let subquestions = QuestionStore.getQuestionsStartingWith(this.subquestionPrefix);

    // Map all subquestions and their children to a more usable format.
    const { parentSubquestions, childSubquestions } = _.reduce(subquestions, (mem, question) => {
      // Skips the control grid question
      if (this.props.question.name === question.name) return mem;

      (question.parent_id === null)
        ? mem.parentSubquestions.push(question)
        : (mem.childSubquestions[question.parent_id] || (mem.childSubquestions[question.parent_id] = [])).push(question);

      return mem;
    }, { parentSubquestions: [], childSubquestions: {} });

    _.each(parentSubquestions, (question) => {
      question.children = childSubquestions[question.id] || [];
      this.subquestions.push(question);
    });


    // The child question of the control grid will be the question that holds the count. This is needed for pricing based on the number of charms
    let childQuestions = QuestionStore.getChildQuestions(this.props.question.id);
    if (childQuestions.length !== 1) {
      console.error('Expected 1 and only 1 child question.');
    }
    this.countQuestion = _.head(childQuestions);
    let countParts = PartStore.fetchPartsForQuestion(this.countQuestion.id);

    this.countPartsMap = _.reduce(countParts, (obj, part) => {
      let value = _.get(part, 'metadata.CountValue');
      if (!value) return obj;

      let num = parseInt(value);
      obj[num] = part;

      return obj;
    }, {});

    let range = _.keys(this.countPartsMap);
    let min = parseInt(_.min(range));
    let max = parseInt(_.max(range));

    let cur = min; // @TODO configurable from metadata
    let countAnswered = 0;

    let answers = AnswerStore.fetchAll();
    let countQuestionAnswer = _.get(answers, this.countQuestion.id);
    if (countQuestionAnswer) {
      let value = parseInt(_.get(countQuestionAnswer, 'part.metadata.CountValue'));
      cur = value;
      countAnswered = value;
    }

    this.updateCountQuestion(cur);

    return {
      activeQuestion: false, // @TODO hydrate?
      cur,
      min,
      max,
      countAnswered
    }
  },

  componentDidMount() {
    if (!this.portalElement) {
      this.portalElement = document.createElement('div');
      document.body.appendChild(this.portalElement);
    }

    this.componentDidUpdate();

    // polyfill for dialog
    _.isElement(this.modalRef) && dialogPolyfill.registerDialog(this.modalRef);
  },

  componentDidUpdate() {
    ReactDOM.render(this.modalMarkup, this.portalElement);
  },

  onAnswerChange(answers) {
    let countAnswered = _.reduce(this.subquestions, (sum, question) => {
      let answer = _.get(answers, [question.id]);
      return answer ? sum + 1 : sum;
    }, 0);

    this.setState({ answers, countAnswered });
  },

  handleGridClick(id) {
    this.changeActiveSubquestion(id);
    let question = _.find(this.subquestions, { 'name': this.subquestionPrefix + id });
    let answered = !!_.get(this.state.answers, [question.id]);
    let disableModal = !!_.get(this.props.question, 'metadata.control.SubquestionControlGrid.DisableModal');

    (answered && !disableModal) ? this.handleModalOpen() : this.scrollToBottomOfQuestion();
  },

  changeActiveSubquestion(id) {
    this.setState({ activeQuestion: id });
    this.handleChangeText(id);
  },

  removeActiveSubquestion() {
    this.setState({ activeQuestion: false });
    this.handleChangeText(null);
  },

  addSubquestion() {
    let { cur, max } = this.state;
    let newCur = cur < max ? cur + 1 : max;
    this.setState({ cur: newCur });
    this.updateCountQuestion(newCur);
    this.changeActiveSubquestion(newCur);
    this.scrollToBottomOfQuestion(this.props.question.name);
  },

  removeSubquestion() {
    let { cur, min, activeQuestion } = this.state;
    let newCur = cur > min ? cur - 1 : min;
    this.setState({ cur: newCur });
    this.updateCountQuestion(newCur);
    // this.changeActiveSubquestion(newCur);
  },

  updateCountQuestion(count) {
    let countPart = _.get(this.countPartsMap, [count]);
    if (countPart === undefined) return;

    AnswerActions.update(this.countQuestion, countPart);
  },

  generateControlMarkup() {
    let controls = _.map(this.subquestions, question => {
      let idRegex = new RegExp('^[A-Z]+([0-9]+)$', 'i');
      let idMatch = idRegex.exec(question.name);
      let id = idMatch !== null ? parseInt(idMatch[1]) : false;

      let answer = _.get(this.state.answers, [question.id]);
      if (!answer && id > this.state.cur) {
        return;
      }

      let part = _.get(this.state.answers, [question.id, 'part']);
      let partName = part ? this.displayPartName(part) : 'Select Your Charm';
      let partImage = part ? Config.images.s3url + _.get(part, 'metadata.StaticImage') : 'https://s3.amazonaws.com/uc-source/new_charm.jpg';
      let partPrice = part ? this.displayPrice(part) : '';

      let editLinkText = _.get(question, 'metadata.control.SubquestionControlGrid.EditLinkText') || 'Edit';
      let editLink = part ? (<p className='uc-subquestion-control-grid-edit-link'>{editLinkText}</p>) : null;

      let header = _.get(question, 'metadata.SubquestionControlGridText') || id;

      let subquestions = _.filter(question.children, subquestion => {
        return _.get(this.state.answers, [subquestion.id])
          && !_.get(subquestion, 'metadata.HideInSubquestionControlGrid');
      });

      let subquestionMarkup = _.map(subquestions, subquestion => {
        let subquestionAnswer = _.get(this.state.answers, [subquestion.id]);
        let questionName = _.get(subquestionAnswer, 'question.metadata.SubquestionControlGridText') || subquestionAnswer.question.name;
        let partName = subquestionAnswer.input || _.get(subquestionAnswer, `part.metadata.lang.${ln}.DisplayName`) || subquestionAnswer.part.name;
        return (
          <p key={subquestion.id}>
            <strong>{questionName}</strong>: {partName}
          </p>
        );
      });

      let activeClass = id === this.state.activeQuestion ? ' uc-active' : '';

      return (
        <a
          key={question.id + '-' + _.get(part, 'id') || id}
          onClick={this.handleGridClick.bind(null, id, question.name)}
          className={'uc-image-select-label' + activeClass}>
          <p>{header}</p>
          <img alt={partName} src={partImage} />
          <p>{partName}</p>
          <p>{partPrice}</p>
          <div className='uc-subquestion-control-grid-subquestions'>
            {editLink}
            {subquestionMarkup}
          </div>
        </a>
      );
    });

    if (this.state.cur < this.state.max && this.state.countAnswered === this.state.cur) {
      let addSubquestionImage = 'https://s3.amazonaws.com/uc-source/charms/icon-plus.svg';
      let addButtonMarkup = (
        <a
          key={this.props.question.id + '-add'}
          onClick={this.addSubquestion}
          className={'uc-image-select-label'}>
          <p>&nbsp;</p>
          <img alt='Add' src={addSubquestionImage} />
          <p>Add a Charm</p>
        </a>
      );

      controls.push(addButtonMarkup);
    }

    return controls;
  },

  generateModalMarkup() {
    let question = _.find(this.subquestions, { 'name': this.subquestionPrefix + this.state.activeQuestion });

    let subquestionMarkup = _
      .chain(_.get(question, 'children') || [])
      .map(childQuestion => {
        return _.get(this.state.answers, [childQuestion.id]);
      })
      .filter(answered => {
        return !!answered;
      })
      .map(answer => {
        let questionName = _.get(answer, 'question.metadata.SubquestionControlGridText') || answer.question.name;
        return (
          <li key={'dialog-grid-' + answer.question.id}>
            <a onClick={this.handleModalAction.bind(null, 'anchor', answer.question.name)}>Change {questionName}</a>
          </li>
        );
      })
      .value() || null;

    return (
      <div>
        <dialog
          id={'uc-subquestion-control-grid-modal-' + this.props.question.id}
          className={'uc-subquestion-control-grid-modal'}
          ref={this.setModalRef}>
          <div className={'uc-subquestion-control-grid-modal-header'}>Edit Charm</div>
          <div className={'uc-subquestion-control-grid-modal-body'}>What would you like to do with Charm {this.state.activeQuestion}?</div>
          <ul>
            <li><a onClick={this.handleModalAction.bind(null, 'scrollParent')}>Change Charm</a></li>
            {subquestionMarkup}
            <li><a onClick={this.handleModalAction.bind(null, 'delete')}>Remove</a></li>
            <li><a onClick={this.handleModalClose}>Cancel</a></li>
          </ul>
        </dialog>
      </div>
    );
  },

  setModalRef(element) {
    this.modalRef = element;
  },

  handleModalOpen() {
    _.isElement(this.modalRef) && this.modalRef.showModal();
  },

  handleModalClose() {
    _.isElement(this.modalRef) && this.modalRef.close();
  },

  scrollToBottomOfQuestion(questionName = this.props.question.name) {
    this.scrollToQuestion(questionName, 'bottom');
  },

  handleModalAction(action, context = false) {
    if (action === 'scrollParent') {
      this.scrollToQuestion(this.props.question.name, 'bottom');
      this.handleModalClose();

      return true;
    }

    if (action === 'anchor' && context !== false) {
      this.handleModalClose();
      this.scrollToQuestion(context);

      return true;
    }

    if (action === 'delete') {
      this.processDelete();

      return true;
    }

    this.handleModalClose();
    return true;
  },

  processDelete(questionName) {
    let question = _.find(this.subquestions, { 'name': this.subquestionPrefix + this.state.activeQuestion });
    if (!question) return false;

    this.removeActiveSubquestion();
    AnswerActions.delete(question);

    _.each(question.children, child => {
      AnswerActions.delete(child);
    });

    // Need to shift answers around
    if (this.state.activeQuestion < this.state.cur) {
      let newAnswers = [];
      for (let i = this.state.activeQuestion + 1; i <= this.state.cur; i++) {
        let prev = i - 1;
        let nextQuestion = QuestionStore.getQuestionByName(this.subquestionPrefix + i);
        let prevQuestion = QuestionStore.getQuestionByName(this.subquestionPrefix + prev);
        let answer = _.get(this.state.answers, nextQuestion.id);
        if (!answer) continue;

        answer.question = prevQuestion;
        newAnswers.push(answer);

        let children = _.find(this.subquestions, { 'name': nextQuestion.name }).children;

        _.each(children, childQuestion => {
          let childAnswer = _.get(this.state.answers, childQuestion.id);
          if (!childAnswer) return;

          let prevChildQuestionName = childQuestion.name.replace(i, prev);
          let prevChildQuestion = QuestionStore.getQuestionByName(prevChildQuestionName);

          childAnswer.question = prevChildQuestion;
          newAnswers.push(childAnswer);

          AnswerActions.delete(childQuestion);
        });

        if (i === this.state.cur) AnswerActions.delete(nextQuestion);
      }

      AnswerActions.batchUpdate(newAnswers);
    }

    this.removeSubquestion();
    this.handleModalClose();
  },

  render() {
    let controls = this.generateControlMarkup();
    this.modalMarkup = this.generateModalMarkup();
    let questionDescription = _.get(this.props.question, 'metadata.DisplayQuestionInfoTextBelowControl') && this.state.countAnswered >= 4 ? (
      <div
        className="uc-question-desc"
        style={{ display: _.get(this.props.question.metadata, `lang.${ln}.DisplayInfoText`) ? 'block' : 'none' }}>
        {_.get(this.props.question.metadata, `lang.${ln}.DisplayInfoText`)}
      </div>
    ) : null;

    return (
      <div>
        <div className='uc-control uc-subquestion-control-grid'>
          {controls}
        </div>
        {questionDescription}
      </div>
    );
  }
});

module.exports = SubquestionControlGrid;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/SubquestionControlGrid.jsx